import { Box, Button, Grid, TextField, Typography } from "@mui/material"
import { TEXT_TITLE_COLOR } from "../../constants/colors"
import useChangeMoneyRiderController from "./controller"
import { numberFormat } from "../../utils/nunberFormat"
import { useTranslation } from "react-i18next"
import ConfirmDialog from "../../components/ConfirmDialog"
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated"

const ChangeMoneyRiderTake = () => {
    const controller = useChangeMoneyRiderController()
    const { t } = useTranslation('global')

    return (
        <>
            
                <Box sx={{ display: controller.loadingData ? 'flex':"none", justifyContent: 'center', alignItems: 'center', }}>
                    <LoadingAnimatedIcon />
                </Box>  <Box sx={{display: !controller.loadingData ? 'block':"none",}}>
                    <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight="bold">{t("multiplier_page.Multiplier Calculate Rider")}</Typography>
                    <Grid container spacing={2} mt={4}>
                        <Grid item xs={12} md={4}>
                            <Box>
                                <form onSubmit={(e) => controller.handleOpenConfirm(e)}>
                                    <Box sx={{ p: 5, boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)', borderRadius: "10px" }}>
                                        <Box>
                                            <Typography>{t("multiplier_page.Base money")}</Typography>
                                            <TextField fullWidth size="small" margin="normal" required inputRef={controller.baseMoney} />
                                        </Box>
                                        <Box>
                                            <Typography>{t("multiplier_page.Base 0-4 km")}</Typography>
                                            <TextField fullWidth size="small" margin="normal" required inputRef={controller.base0to4} />
                                        </Box>
                                        <Box>
                                            <Typography>{t("multiplier_page.Base 5-more km")}</Typography>
                                            <TextField fullWidth size="small" margin="normal" required inputRef={controller.base5toMore} />
                                        </Box>
                                        <Box>
                                            <Typography>{t("multiplier_page.Percent")}</Typography>
                                            <TextField fullWidth size="small" margin="normal" required inputRef={controller.percent} type="number" />
                                        </Box>
                                        {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
                                        <Box mt={2} sx={{ display: 'flex', justifyContent: 'right' }}>
                                            <Button type="submit" variant="contained" color="secondary" sx={{ textTransform: 'none', color: '#fff' }}>
                                                {t("multiplier_page.Change Multiplier")}
                                            </Button>
                                        </Box>
                                    </Box>
                                </form>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ p: 4, boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)', borderRadius: "10px" }}>
                                <Typography variant="h5" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("multiplier_page.Multiplier Money Rider")}</Typography>
                                <Box m={1} mt={1}>
                                    <Typography>{t("multiplier_page.Base money")} : <span style={{ color: 'red' }}>{numberFormat(controller.oldMultiplier?.baseMoney)} {t("Kip")}</span> </Typography>
                                </Box>
                                <Box m={1}>
                                    <Typography>{t("multiplier_page.Base 0-4 km")} : <span style={{ color: 'red' }}>{numberFormat(controller.oldMultiplier?.baseMoney0to4)} {t("Kip")}</span> </Typography>
                                </Box>
                                <Box m={1}>
                                    <Typography>{t("multiplier_page.Base 5-more km")} : <span style={{ color: 'red' }}>{numberFormat(controller.oldMultiplier?.baseMoney5toEach)} {t("Kip")}</span></Typography>
                                </Box>
                                <Box m={1}>
                                    <Typography>{t("multiplier_page.Percent")} : <span style={{ color: 'red' }}>{numberFormat(controller.oldMultiplier?.percent)} %</span></Typography>
                                </Box>
                                <Box m={1}>
                                    <Typography>{t("multiplier_page.Change By Name")} : <span style={{ color: 'red' }}>{controller.oldMultiplier?.updateBy}</span></Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <ConfirmDialog
                        open={controller.openConfirm}
                        title={t("multiplier_page.Do you want to change Multiplier?")}
                        loading={controller.loadingData}
                        onCancel={controller.handleCloseConfirm}
                        onConfirm={() => controller.handleUpdateMultiplier()}
                    />
                </Box>
            

        </>
    )
}
export default ChangeMoneyRiderTake